import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { LandingPage } from "./pages/LandingPage";
import { ExplorePage } from "./pages/ExplorePage";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { CookieConsent } from "./components/CookieConsent";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="App">
        <div className="header-wrapper">
          <div className="header">
            <Link
              to="/"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                textDecoration: "none",
                color: "inherit",
              }}
            >
              <div className="logo-img">
                <img
                  src="https://findmore.solutions/wp-content/uploads/2025/03/Logo-Findmore-Solutions.svg"
                  alt="Findmore Logo"
                />
              </div>
            </Link>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "12px",
                alignItems: "center",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <div className="live-badge">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 12 12"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="6" cy="6" r="3" fill="#22c55e">
                      <animate
                        attributeName="opacity"
                        values="1;0.3;1"
                        dur="2s"
                        repeatCount="indefinite"
                      />
                    </circle>
                    <circle
                      cx="6"
                      cy="6"
                      r="3"
                      fill="none"
                      stroke="#22c55e"
                      strokeWidth="1"
                    >
                      <animate
                        attributeName="r"
                        values="3;5"
                        dur="2s"
                        repeatCount="indefinite"
                      />
                      <animate
                        attributeName="opacity"
                        values="0.8;0"
                        dur="2s"
                        repeatCount="indefinite"
                      />
                    </circle>
                  </svg>
                  <span
                    className="live-text"
                    style={{
                      color: "#22c55e",
                      fontSize: "10px",
                      fontWeight: "bold",
                      letterSpacing: "0.5px",
                      lineHeight: 1,
                    }}
                  >
                    LIVE
                  </span>
                </div>
              </div>
              <div>
                <div className="logo-text">Now ECS2026</div>
                <div className="logo-tag">Let's connect!</div>
              </div>
            </div>
          </div>
        </div>

        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/explore" element={<ExplorePage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>
        <CookieConsent />
      </div>
    </Router>
  );
}

export default App;
